<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>equipment.details.modals.add-handset.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close"></i>
        </button>
      </div>
      <div *ngIf="loading">
        <ngx-skeleton-loader [theme]="{'height':'200px'}"></ngx-skeleton-loader>
      </div>
      <div *ngIf="!loading" class="vox-inline-message vox-inline-message_light-grey">
        <div>
          <i class="icon-small-info"></i>
          <span [innerHTML]="'equipment.details.modals.add-handset.ipui-disclaimer' | translate"></span>
        </div>
      </div>
      <form [formGroup]="form" *ngIf="!loading">
        <div class="form-group">
          <label for="ipui" translate>equipment.details.modals.add-handset.ipui-label</label>
          <div class="vox-input-group vox-input-group_dense" [ngClass]="{
            'vox-input-group_invalid': isFieldValid('ipui')
          }">
            <input class="vox-text-field" type="text" id="ipui" formControlName="ipui" [placeholder]="'equipment.details.modals.add-handset.ipui-placeholder' | translate"/><i
              class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
              *ngIf="form.get('ipui').errors && form.get('ipui').errors.required" class="vox-input-group__error-message" translate>equipment.details.modals.add-handset.error-required</span>
              <span
              *ngIf="form.get('ipui').errors && form.get('ipui').errors.pattern" class="vox-input-group__error-message" translate>equipment.details.modals.add-handset.error-pattern</span>
          </div>
        </div>
        <div *ngIf="equipment.pbx" class="form-group">
          <label for="company" translate>equipment.details.modals.add-handset.user-label</label>
          <div ngbDropdown class="vox-dropdown-input" placement="bottom">
            <button
              id="handset-user-dropdown"
              ngbDropdownToggle
              >
              <span *ngIf="!selectedUser" translate>equipment.details.modals.assigned-user.user-placeholder</span>
              <span *ngIf="selectedUser">{{selectedUser.firstName}} {{selectedUser.lastName}} ({{selectedUser.extension}})</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="handset-user-dropdown">
              <button ngbDropdownItem
              type="button"
              *ngFor="let user of users; let idx = index"
              (click)="onSelectUser(user)"
              translate>
              {{user.firstName}} {{user.lastName}} ({{user.extension}})
            </button>
            </div>
          </div>
        </div>
        <div class="submit-container">
          <button class="vox-btn vox-btn-primary" type="submit" [disabled]="form.invalid" (click)="addHandset()" [ladda]="loadingAdd" data-spinner-color="grey" data-style="zoom-in" >
            <span translate>equipment.details.modals.add-handset.add-button</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
